export default __webpack_public_path__ + "static/media/rectangle4@3x.06d23a16.png";